import { PAYOUT_DRAFTS_TITLE_TEST_ID } from './constants';
import type { FiltersState } from './localState';
import { PayoutDraftFilters } from './PayoutDraftFilters';

type Props = {
  filters: FiltersState;
  setFilters: (filtersState: FiltersState) => void;
  resetState: () => void;
};

export const PayoutDraftsHeader = (props: Props) => {
  return (
    <div className="w-full items-center">
      <div className="mb-6 flex h-10 w-full flex-row justify-between">
        <div
          className="text-2xl font-medium"
          data-testid={PAYOUT_DRAFTS_TITLE_TEST_ID}
        >
          Payout drafts
        </div>
      </div>
      <div className="flex w-full flex-row justify-between">
        <PayoutDraftFilters {...props} />
      </div>
    </div>
  );
};
